<mat-icon *ngIf="parent && state === 'IN_PROGRESS'" >schedule</mat-icon>
<i [class]="state">{{description}}</i>
